export default [
  {
    title: 'По названию (А-я)',
    field: 'name.asc',
    options: {
      by: 'name',
      order: 'asc'
    }
  },
  {
    title: 'По названию (Я-а)',
    field: 'name.desc',
    options: {
      by: 'name',
      order: 'desc'
    }
  },
  {
    title: 'По цене(возрастанию)',
    field: 'price.asc',
    options: {
      by: 'price',
      order: 'asc'
    }
  },
  {
    title: 'По цене(убыванию)',
    field: 'price.desc',
    options: {
      by: 'price',
      order: 'desc'
    }
  },
  
]